import fetch from 'auth/FetchInterceptor'

const sistemaData = {}

let path = 'api/sistema';

sistemaData.tiposParentesco = function () {
  return fetch({
    url: `${path}/parentescos`,
    method: 'get',
  })
}

sistemaData.localidadEstados = function () {
  return fetch({
    url: `${path}/mx/estados`,
    method: 'get',
  })
}

sistemaData.localidadMunicipios = function (id_estado) {
  return fetch({
    url: `${path}/mx/estados/`+id_estado,
    method: 'get',
  })
}

sistemaData.Importaciones = function () {
  return fetch({
    url: `${path}/importar/historial`,
    method: 'get',
  })
}

sistemaData.Importar = function (tipo='',data) {
  return fetch({
    url: `${path}/importar/`+tipo,
    method: 'post',
    data:data
  })
}

sistemaData.hacerPrincipalDominio = function (domain,subdomain) {
  return fetch({
    url: `${path}/dominios/hacerPrincipal`,
    method: 'post',
    data:{domain,subdomain}
  })
}


sistemaData.verificarDominio = function (domain) {
  return fetch({
    url: `${path}/dominios/verificar`,
    method: 'post',
    data:{domain}
  })
}

sistemaData.agregarDominio = function (domain) {
  return fetch({
    url: `${path}/dominios/agregar`,
    method: 'post',
    data:{domain}
  })
}


sistemaData.eliminarDominio = function (domain) {
  return fetch({
    url: `${path}/dominios`,
    method: 'delete',
    data:{domain}
  })
}




sistemaData.listarDominios = function () {
  return fetch({
    url: `${path}/dominios/listar`,
    method: 'get',
    
  })
}


sistemaData.verificarConexion = function (data) {
  return fetch({
    url: `${path}/mail/verificarConexion`,
    method: 'post',
    data:data
  })
}

sistemaData.dataMail = function (params) {
  return fetch({
    url: `${path}/mail/`,
    method: 'get',
    params
  })
}


sistemaData.cambiarStyleTheme = function (data) {
  return fetch({
    url: `${path}/theme/cambiarStyleTheme`,
    method: 'put',
    data:data
  })
}

sistemaData.changeTexts = function (data) {
  return fetch({
    url: `${path}/theme/change-texts`,
    method: 'put',
    data:data
  })
}

sistemaData.changeLinksTerms = function (data) {
  return fetch({
    url: `${path}/theme/links-terms`,
    method: 'put',
    data:data
  })
}
sistemaData.getLinksTerms = function (params) {
  return fetch({
    url: `${path}/theme/links-terms`,
    method: 'get',
    params
  })
}

sistemaData.getCustomtexts = function (params) {
  return fetch({
    url: `${path}/theme/custom-texts`,
    method: 'get',
    params
  })
}


sistemaData.DashCheckListContent = function (params) {
  return fetch({
    url: `${path}/dashboard/checkListContent`,
    method: 'get',
    params
  })
}


sistemaData.DashUsuariosCount = function (params) {
  return fetch({
    url: `${path}/dashboard/usuarios-count`,
    method: 'get',
    params
  })
}

sistemaData.RolesCapacidades = function (tipoUsuario) {
  return fetch({
    url: `${path}/roles/capacidades`,
    method: 'get',
    params:{tipoUsuario}
  })
}

sistemaData.RolesCapacidadesID = function (rol) {
  return fetch({
    url: `${path}/roles/capacidadesids-roles`,
    method: 'get',
    params:{rol}
  })
}

sistemaData.RolesActualizarCapacidades = function (data) {
  return fetch({
    url: `${path}/roles/capacidades-actualizar`,
    method: 'put',
    data
  })
}


sistemaData.RolesCopiar = function (data) {
  return fetch({
    url: `${path}/roles/copiar`,
    method: 'post',
    data
  })
}
sistemaData.RolesEliminar = function (id) {
  return fetch({
    url: `${path}/roles/${id}`,
    method: 'delete',
  })
}


sistemaData.SearchItem = function (b) {
  return fetch({
    url: `${path}/search`,
    method: 'get',
    params:{b}
  })
}

sistemaData.getDataAuthGoogle = function (params) {
  return fetch({
    url: `${path}/auths/getDataAuthGoogle`,
    method: 'get',
    params
  })
}


sistemaData.updateDataAuthGoogle = function (data) {
  return fetch({
    url: `${path}/auths/updateDataAuthGoogle`,
    method: 'post',
    data
  })
}

sistemaData.updateDataParametros = function (data) {
  return fetch({
    url: `${path}/parametros`,
    method: 'post',
    data
  })
}


sistemaData.getDataParametros = function (data) {
  return fetch({
    url: `${path}/parametros`,
    method: 'get',
    data
  })
}

export default sistemaData